"use strict";

var _interopRequireDefault = require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changePassword = changePassword;
exports.codeLogin = codeLogin;
exports.getProwerUrl = getProwerUrl;
exports.getUserInfo = getUserInfo;
exports.login = login;
exports.logout = logout;
exports.ticketLoginRequest = ticketLoginRequest;
var _request = _interopRequireDefault(require("@/utils/request"));
function login(data) {
  return (0, _request.default)({
    url: '/api/v1/auth/login/login',
    method: 'post',
    data: data
  });
}
function changePassword(data) {
  return (0, _request.default)({
    url: 'api/v1/user/update/password',
    method: 'patch',
    data: data
  });
}
function ticketLoginRequest(data) {
  return (0, _request.default)({
    url: '/api/v1/auth/login/ticketLogin',
    method: 'post',
    data: data
  });
}
function logout() {
  return (0, _request.default)({
    url: '/api/v1/auth/login/logout',
    method: 'post'
  });
}
function getUserInfo() {
  return (0, _request.default)({
    url: "/api/v1/user/_",
    method: 'get'
  });
}
function getProwerUrl() {
  return (0, _request.default)({
    url: '/api/v1/auth/feishu',
    method: 'get'
  });
}
function codeLogin(params) {
  return (0, _request.default)({
    url: "/api/v1/auth/feishu/login",
    method: 'get',
    params: params
  });
}